const movementRequestStatus = {
  approved: 'approved',
  refused: 'refused'
};

module.exports = movementRequestStatus;
